







































import Vue from 'vue';

export default Vue.extend({
  name: 'TableFull',

  props: {
    content: Array,
    empty: Boolean,
    
    deleteButton: Function,
    editButton: Function
  },


});
